import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyDnz7r-mA-FhXHPfHel_KGtYlds4o2-MLI',
  authDomain: 'msdat-configurer.firebaseapp.com',
  projectId: 'msdat-configurer',
  storageBucket: 'msdat-configurer.firebasestorage.app',
  messagingSenderId: '450508148462',
  appId: '1:450508148462:web:0ffac42912ee87e05e6dff',
  measurementId: 'G-LKGY5LL1FM',
};

// Initialize Firebase
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const db = firebase.firestore();
export const auth = firebase.auth();

export default db;
